import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles as styles } from './style/gstheme';
import GS from '../grafsync/grafsync';

class ExternalTypeLink extends React.Component {

    handleDeleteLink() {
        // We might need to remove a link because the type is being removed (i.e. hasNamedIndividual)
        if (this.props.id === "NamedIndividual" && this.props.removeTypeProperty) {
            GS.deleteProperty("http://www.w3.org/2002/07/owl#Thing", this.props.graph, this.props.removeTypeProperty, this.props.source);
        }
        // We do this directly to ensure direction of link delete is correct
        GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.id);
        // If we're removing a relationhip we redirect to component home
        if (this.props.link) {
            this.props.history.push(this.props.link);
        }
    }

    render() {

        const { id, isReadOnly, classes, highlight, label, compact, superCompact } = this.props;

        return (
            <Chip
                color="primary"
                style={highlight ?
                    { backgroundColor: '#CA4F0C' }
                    :
                    {}
                }
                data-test={highlight ? "highlighted-external-type-link" : "external-type-link"}
                className={superCompact ?
                    classes.noMarginChip
                    :
                    compact ?
                        classes.compactChip
                        :
                        classes.chip}
                onDelete={!isReadOnly ? (() => this.handleDeleteLink()) : null}
                label={label || id} />
        );
    }
}

ExternalTypeLink.defaultProps = {
    property: "type",
    highlight: false,
    compact: false,
    superCompact: false
};

ExternalTypeLink.propTypes = {
    id: PropTypes.string.isRequired,
    highlight: PropTypes.bool,
    compact: PropTypes.bool,
    superCompact: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    removeTypeProperty: PropTypes.string,
    property: PropTypes.string,
    label: PropTypes.string,
    source: PropTypes.string,
    sourceComponnet: PropTypes.string,
    isReadOnly: PropTypes.bool,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(ExternalTypeLink));